import React from "react"
import { Link } from "gatsby"
import Title from "../Globals/Title"
export default function Info() {
  return (
    <section className="py-5">
      <div className="container">
        <Title title="About Us" />
        <div className="row">
          <div className="col-10 col-sm-8 mx-auto text-center">
            <h3>Share Life. Build Community.</h3>
            <p className="lead text-muted mb-5">
              We want to share our space, our craft, our life with you. You are
              welcome to come in and be who you are, to share life here. Our
              coffee, beer and wine lists, our food menu and event offerings are
              all here to make room for community to grow. We roast our own
              coffee in our roastery, Hold Fast Coffee Co, to ensure that this
              staple of our cafe is full of quality and beauty. Our aim is to
              create a space in which selfless acts are the norm, and trust
              becomes natural. No matter if big or small, simple or completely
              out-of-the-box, we are committed to service that brings joy. It is
              our mission to push serving others as far as it will go with
              whatever we each have to give to create as much joy as we can.
              Share life, build community.
            </p>
            <Link to="/about/">
              <button className="btn text-uppercase btn-yellow">
                about page
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
